export default __webpack_public_path__ + "61155b4357352fd32f23363d9eef706b.svg";